@if (loading) {
  <div class="row">
    <mat-progress-bar mode="indeterminate" color="primary"></mat-progress-bar>
  </div>
}

@if (!loading && surveyDashboard) {
  <div class="container-fluid my-4">

    @for (key of objectKeys(surveyDashboard); track key) {
      @if (surveyDashboard[key]?.questions.data?.length > 0) {
        <div class="container-fluid accordion-container accordion-inner mb-4"
          >
          <mat-accordion class="accordion">
            <mat-expansion-panel expanded>
              <mat-expansion-panel-header>
                <mat-panel-title>
                  {{ "service.survey-service.question-typologies." + (key | lowercase) + ".title" | translate }}
                </mat-panel-title>
              </mat-expansion-panel-header>
              <!-- Mostra tabella solo se ci sono elementi -->
              <div>
                @if (key === 'CONSENSUS') {
                  <div echarts [options]="surveyCharts[key]" class="chart w-100 my-4"></div>
                  <div class="box py-0 px-2 bg-transparent border-0 mb-0">
                    <mat-label class="box-title px-3 mb-0">{{ 'generic.filters' | translate }}</mat-label>
                  </div>
                  <div class="card p-3">
                  <div class="row justify-content-around">
                    <div class="col-lg-6 col-12 text-center pb-4">
                      <!-- Label centrata sopra gli slider -->
                      <label class="form-label fw-bold d-block mb-2">
                        {{ "components.responses.consensus.agree" | translate }} (%)
                      </label>
                      <!-- Primo slider -->
                      <mat-slider [displayWith]="formatPercent" [discrete]="true">
                        <input matSliderThumb name="agree_0_{{key}}" min="0" max="100" step="1" [(ngModel)]="filters.agree[0]"
                          (ngModelChange)="updateFilter(key, 'agree', $event, 0)">
                      </mat-slider>
                      <!-- Secondo slider -->
                      <mat-slider class="slider-primary" [displayWith]="formatPercent" [discrete]="true">
                        <input matSliderThumb name="agree_1_{{key}}" min="0" max="100" step="1" [(ngModel)]="filters.agree[1]"
                          (ngModelChange)="updateFilter(key, 'agree', $event, 1)">
                      </mat-slider>
                    </div>
                    <!-- Filter: Certainty -->
                    <div class="col-lg-6 col-12 text-center border-left-grey pb-4">
                      <!-- Label centrata sopra gli slider -->
                      <label class="form-label fw-bold d-block mb-2">
                        {{ "generic.certainty-degree" | translate }} (%)
                      </label>
                      <!-- Primo slider -->
                      <mat-slider [displayWith]="formatPercent" [discrete]="true">
                        <input matSliderThumb name="certainty_0_{{key}}" min="0" max="100" step="1" [(ngModel)]="filters.certainty[0]"
                          (ngModelChange)="updateFilter(key, 'certainty', $event, 0)">
                      </mat-slider>
                      <!-- Secondo slider -->
                      <mat-slider class="slider-primary" [displayWith]="formatPercent" [discrete]="true">
                        <input matSliderThumb name="certainty_1_{{key}}" min="0" max="100" step="1" [(ngModel)]="filters.certainty[1]"
                          (ngModelChange)="updateFilter(key, 'certainty', $event, 1)">
                      </mat-slider>
                    </div>
                    <!-- Filter: Contradiction -->
                    <div class="col-lg-6 col-12 mb-3 text-center border-bottom-grey pb-4">
                      <!-- Label centrata sopra gli slider -->
                      <label class="form-label fw-bold d-block mb-2">
                        {{ "components.responses.consensus.disagree" | translate }} (%)
                      </label>
                      <!-- Primo slider -->
                      <mat-slider [displayWith]="formatPercent" [discrete]="true">
                        <input matSliderThumb name="disagree_0_{{key}}" min="0" max="100" step="1" [(ngModel)]="filters.disagree[0]"
                          (ngModelChange)="updateFilter(key, 'disagree', $event, 0)">
                      </mat-slider>
                      <!-- Secondo slider -->
                      <mat-slider class="slider-primary" [displayWith]="formatPercent" [discrete]="true">
                        <input matSliderThumb name="disagree_1_{{key}}" min="0" max="100" step="1" [(ngModel)]="filters.disagree[1]"
                          (ngModelChange)="updateFilter(key, 'disagree', $event, 1)">
                      </mat-slider>
                    </div>
                    <div class="col-lg-6 col-12 mb-3 text-center border-left-grey border-bottom-grey pb-4">
                      <!-- Label centrata sopra gli slider -->
                      <label class="form-label fw-bold d-block mb-2">
                        {{ "generic.contradiction-degree" | translate }} (%)
                      </label>
                      <!-- Primo slider -->
                      <mat-slider [displayWith]="formatPercent" [discrete]="true">
                        <input matSliderThumb name="contradiction_0_{{key}}" min="0" max="100" step="1" [(ngModel)]="filters.contradiction[0]"
                          (ngModelChange)="updateFilter(key, 'contradiction', $event, 0)">
                      </mat-slider>
                      <!-- Secondo slider -->
                      <mat-slider class="slider-primary" [displayWith]="formatPercent" [discrete]="true">
                        <input matSliderThumb name="contradiction_1_{{key}}" min="0" max="100" step="1" [(ngModel)]="filters.contradiction[1]"
                          (ngModelChange)="updateFilter(key, 'contradiction', $event, 1)">
                      </mat-slider>
                    </div>
                    <ng-container class="mt-5">
                      <div class="col-lg-4 mb-3 col-12 align-items-center">
                        <mat-form-field class="select-primary w-100" appearance="fill">
                          <mat-label>{{ 'generic.section-filter' | translate }}</mat-label>
                          <mat-select name="filter_section" (selectionChange)="updateSectionFilter(key, $event.value)">
                            <mat-option value="">{{ "generic.all" | translate }}</mat-option>
                            @for (sec of keyQuestionsSections(key); track sec) {
                              <mat-option [value]="sec">
                                {{ sec }}
                              </mat-option>
                            }
                          </mat-select>
                        </mat-form-field>
                      </div>
                      <div class="col-lg-4 mb-3 col-12 align-items-center">
                        <mat-form-field class="select-primary w-100" appearance="fill">
                          <mat-label>{{ 'generic.preliminary-round-assessment-filter' | translate }}</mat-label>
                          <mat-select name="filter_section" [multiple]="true"
                            (selectionChange)="updateStatusFilter(key, $event.value)">
                            @for (sec of keyQuestionsStatuses(key); track sec) {
                              <mat-option [value]="sec">
                                {{ "components.surveys.survey-dashboard.survey-dashboard.component." + (sec | lowercase) |
                                translate }}
                              </mat-option>
                            }
                          </mat-select>
                        </mat-form-field>
                      </div>
                    </ng-container>
                  </div>
                </div>
                }
                <!-- Card-based layout (come nell'immagine di riferimento) -->
                <div class="revision-cards-container my-4">
                  @for (element of getPaginatedQuestions(key); track element.id; let i = $index) {
                    <div class="revision-card border-primary">
                      <div class="revision-card-header">
                        {{ element.statement || element.question || 'N/A' }}
                      </div>
                      <div class="revision-card-body">
                        <div class="revision-card-grid" [style.grid-template-columns]="key === 'CONSENSUS' ? '1fr 1.2fr 2fr 1.5fr' : '1fr'">
                        
                        @if (key === 'CONSENSUS') {
                          <div class="revision-grid-cell">
                            <div class="revision-cell-content">
                              <div class="revision-cell-title">{{ "generic.votes" | translate }}</div>
                              <div><strong class="vote-label vote-label-agree">{{ "generic.agree" | translate }}:</strong> {{ element.agree_count }} ({{ element.agree_perc | number:'1.0-2' }}%)</div>
                              <div><strong class="vote-label vote-label-disagree">{{ "generic.disagree" | translate }}:</strong> {{ element.disagree_count }} ({{ element.disagree_perc | number:'1.0-2' }}%)</div>
                              @if (!element.required) {
                                <div><strong>{{ "generic.abstained" | translate }}:</strong> {{ element.abstained_count }} ({{ element.abstained_perc | number:'1.0-2' }}%)</div>
                              }
                            </div>
                          </div>
                          <div class="revision-grid-cell">
                            <div class="revision-cell-content">
                              <div class="revision-cell-title">{{ "geneneric.consensus-indexes" | translate }}</div>
                              <div><strong>Certainty:</strong> {{ element.certainty_degree | number:'1.0-2' }}%</div>
                              <div><strong>Contradiction:</strong> {{ element.contradiction_degree | number:'1.0-2' }}%</div>
                            </div>
                          </div>
                          <div class="revision-grid-cell revision-cell-hint">
                            <div class="revision-cell-content">
                              <div class="revision-cell-title">{{ "generic.hint" | translate }}</div>
                              <div class="revision-hint-body">
                                <span class="revision-hint-text">{{ ("components.surveys.survey-dashboard.survey-dashboard.component." + (element.status | lowercase)) + ".title" | translate }}</span>
                                @if (element.showSubtitle) {
                                  <div class="mt-1">
                                    {{ ("components.surveys.survey-dashboard.survey-dashboard.component." + (element.status | lowercase)) + ".subtitle" | translate }}
                                  </div>
                                }
                                <div>
                                  <b style="cursor: pointer; font-size: 0.8em; color: #7B55C8" (click)="element.showSubtitle = !element.showSubtitle">
                                    vedi dettagli
                                  </b>
                                </div>
                              </div>
                              <mat-chip selectable="true" (click)="element.showSubtitle = !element.showSubtitle" selected="true"
                                style="justify-content:center; pointer-events:none;" class="text-white hint-chip hint-chip-top-right" [ngStyle]="{
                                  'background-color': element.status === 'ACCEPTED' ? '#00bc1d' :
                                    element.status === 'REJECTED' ? '#ff0000' : '#FFAD4A'
                                }">
                                {{ (element.status === 'REJECTED' || element.status === 'ACCEPTED'
                                  ? "components.surveys.survey-dashboard.survey-dashboard.component." + (element.status | lowercase)
                                  : "components.surveys.survey-dashboard.survey-dashboard.component.to_revision") | translate }}
                              </mat-chip>
                            </div>
                          </div>
                        }

                        <div class="revision-grid-cell revision-cell-actions">
                          <div class="revision-cell-content">
                            <div class="revision-cell-title">{{ "generic.final-decision" | translate }}</div>
                            @if (element.rewriting) {
                              <div class="rewriting-indicator">
                                <mat-spinner diameter="20" strokeWidth="3"></mat-spinner>
                                <span class="rewriting-label">{{ "generic.rewriting" | translate }}</span>
                              </div>
                            } @else {
                              <app-survey-final-decision-selector
                                [element]="element"
                                [survey]="survey"
                                [statuses]="surveyService.questionFinalDecisionStatuses"
                                (decisionChange)="setFinalDecision($event.element, $event.decision)"
                                [appDisableRole]="['VIEWER']" [currentRole]="currentUserInTeam?.role"
                              />
                            }
                          </div>
                        </div>
                        </div>
                      </div>
                      
                      @if (key === 'CONSENSUS') {
                        <div class="revision-card-footer">
                          <div class="revision-footer-title">
                            <mat-icon class="revision-footer-icon">auto_awesome</mat-icon>
                            <!-- <span>{{ "generic.ai-revision-proposal" | translate }}</span> -->
                            <span>{{ "generic.ai-revision-proposal" | translate }}</span>
                          </div>
                          @if (element.ai_revision_proposal) {
                            <div class="revision-footer-content">{{ element.ai_revision_proposal }}</div>
                          } @else {
                            <span class="revision-footer-placeholder">N/A</span>
                          }
                        </div>
                      }
                    </div>
                  }
                </div>
                <mat-paginator
                  [length]="getFilteredQuestions(key).length"
                  [pageSize]="getPaginationState(key).pageSize"
                  [pageIndex]="getPaginationState(key).pageIndex"
                  [pageSizeOptions]="[5, 10, 20, 50]"
                  showFirstLastButtons
                  (page)="onPageChange(key, $event)">
                </mat-paginator>

                <!-- Tabella originale (commentata per poterla ripristinare) -->
                <!--
                <table mat-table [dataSource]="surveyDashboard[key]?.questions"
                  class="mat-elevation-z8 w-100 my-4 table table-bordered" style="table-layout: fixed;">
                  <ng-container matColumnDef="section">
                    <th mat-header-cell *matHeaderCellDef class="text-center align-middle"> {{ "generic.section" | translate }}</th>
                    <td mat-cell *matCellDef="let element" class="text-center align-middle">{{ element.section || 'N/A' }}</td>
                  </ng-container>
                  <ng-container matColumnDef="statement">
                    <th mat-header-cell *matHeaderCellDef class="text-center align-middle"> {{ "generic.statement" | translate }}</th>
                    <td mat-cell *matCellDef="let element" class="text-center align-middle">{{ element.statement }}</td>
                  </ng-container>
                  <ng-container matColumnDef="votes">
                    <th mat-header-cell *matHeaderCellDef class="text-center align-middle"> {{ "generic.votes" | translate }}</th>
                    <td mat-cell *matCellDef="let element" class="text-center align-middle">
                      <div class="d-flex flex-column justify-content-center align-items-center">
                        <span class="vote-item">✅ {{ element.agree_count }} ({{ element.agree_perc | number:'1.0-2' }}%)</span>
                        <span class="vote-item">❌ {{ element.disagree_count }} ({{ element.disagree_perc | number:'1.0-2' }}%)</span>
                        @if (!element.required) {
                          <span class="vote-item">⏸️ {{ element.abstained_count }} ({{ element.abstained_perc | number:'1.0-2' }}%)</span>
                        }
                      </div>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="consensus_indexes">
                    <th mat-header-cell *matHeaderCellDef class="text-center align-middle"> {{ "geneneric.consensus-indexes" | translate }}</th>
                    <td mat-cell *matCellDef="let element" class="text-center align-middle">
                      <div><strong>Certainty:</strong> {{ element.certainty_degree | number:'1.0-2' }}%</div>
                      <div><strong>Contradiction:</strong> {{ element.contradiction_degree | number:'1.0-2' }}%</div>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef class="text-center align-middle">{{ "generic.preliminary-round-assessment" | translate }}</th>
                    <td mat-cell *matCellDef="let element" class="text-center align-middle">
                      <mat-chip selectable="true" (click)="element.showSubtitle = !element.showSubtitle" selected="true"
                        style="justify-content:center; pointer-events:none;" class="text-white w-100" [ngStyle]="{
                          'background-color': element.status === 'ACCEPTED' ? '#00bc1d' :
                            element.status === 'REJECTED' ? '#ff0000' : '#FFAD4A'
                        }">
                        {{ (element.status === 'REJECTED' || element.status === 'ACCEPTED'
                          ? "components.surveys.survey-dashboard.survey-dashboard.component." + (element.status | lowercase)
                          : "components.surveys.survey-dashboard.survey-dashboard.component.to_revision") | translate }}
                      </mat-chip>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="hint">
                    <th mat-header-cell *matHeaderCellDef class="text-center align-middle">{{ "generic.hint" | translate }}</th>
                    <td mat-cell *matCellDef="let element" class="text-center align-middle">
                      <b>{{ ("components.surveys.survey-dashboard.survey-dashboard.component." + (element.status | lowercase)) + ".title" | translate }}</b>
                      <br>
                      <b style="cursor: pointer; font-size: 0.8em; color: #7B55C8" (click)="element.showSubtitle = !element.showSubtitle">see details</b>
                      @if (element.showSubtitle) {
                        <span><br>{{ ("components.surveys.survey-dashboard.survey-dashboard.component." + (element.status | lowercase)) + ".subtitle" | translate }}</span>
                      }
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="ai_revision_proposal">
                    <th mat-header-cell *matHeaderCellDef class="text-center align-middle"> AI Revision Proposal</th>
                    <td mat-cell *matCellDef="let element" class="text-center align-middle"> N/A </td>
                  </ng-container>
                  <ng-container matColumnDef="final_decision">
                    <th mat-header-cell *matHeaderCellDef class="text-center align-middle"> Final Decision</th>
                    <td mat-cell *matCellDef="let element" class="text-center align-middle">
                      <div class="d-flex flex-column">
                        @for (status of surveyService.questionFinalDecisionStatuses; track status) {
                          @if (!element.final_decision || element.final_decision === status.id) {
                            <button [disabled]="survey?.is_revised" (click)="setFinalDecision(element, status.id)" mat-button
                              class="my-2 btn btn-block text-wrap final-decision-button" mat-raised-button
                              [ngStyle]="{ 'background-color': status.bgcolor, 'color': 'white', 'width': '100%' }">
                              <mat-icon style="margin-right: 2px; color: #e0ffe0;">{{ status.icon }}</mat-icon>
                              <small>{{ survey?.is_revised ? status.title : status.titleNoRev }}</small>
                            </button>
                          }
                        }
                      </div>
                    </td>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="consensusDisplayedColumns"></tr>
                  <tr mat-row *matRowDef="let row; columns: consensusDisplayedColumns;"></tr>
                </table>
                <mat-paginator [pageSizeOptions]="[5, 10, 20, 50]" showFirstLastButtons></mat-paginator>
                -->
                  </div>
                </mat-expansion-panel>
              </mat-accordion>
            </div>
          }
        }
        @if (!survey?.is_revised) {
          <div class="row justify-content-center">
            <button class="btn-custom text-white my-5" matButton="filled" [disabled]="previewLoading"
              (click)="previewSurveyRevision()" *appHasRole="['OWNER', 'EDITOR']; role: currentUserInTeam?.role">
              @if (previewLoading) {
                <mat-spinner diameter="20" strokeWidth="3" class="button-spinner">
                </mat-spinner>
              }
              @if (!previewLoading) {
                <span>{{ 'modals.modal-survey-details.review-survey' | translate }}</span>
              }
            </button>
          </div>
        }
      </div>
    }
